import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {applicationViewFactory} from './application-view.factory';

import SCHEMA from './application-view.schema.yaml';
import PALETTE_SCHEMA from './application-view.palette-schema.yaml';

class ApplicationViewFeature extends AbstractVisualFeature {
    get name() {
        return 'ApplicationView';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return applicationViewFactory(PALETTE);
    }

    afterMojitoConfigBuild(mojitoConfig) {
        const configurations = ensureHierarchy(mojitoConfig, 'services.configurations');
        const applicationFooter = ensureHierarchy(mojitoConfig, 'services.viewImplementations.ApplicationFooter');
        const {backToTopHide, _mobile_backToTopHide} = this.config;

        mergeTo(configurations, {
            AppViewSportsbook: {
                applicationFooter: {
                    hide: applicationFooter.implementation ? ApplicationConfig.isEmbedded : true,
                },
                backToTopButtonToggle: {
                    hide: isMobile() ? _mobile_backToTopHide : backToTopHide,
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

export const ApplicationView = new ApplicationViewFeature(allVisuals);
